var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-tabs',{attrs:{"tabs-id":"user-purchases-overview-tabs","tabs":_vm.tabs,"props":{
      payPeriod: _vm.$enums.StripeEnums.Checkout.Mode.PAYMENT,
    }}})
}
var staticRenderFns = []

export { render, staticRenderFns }